import React from 'react'
import withIcon from '@/components/withIcon'

const IconSpecialConsiderations = ({ className }) => {
  return (
    <svg
      className={className}
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
    >
      <g
        strokeWidth="1.5"
        transform="translate(0.5, 0.5)"
      >
        <path
          d="M13.476,16H19c2.817,0,3,2,3,2L10.235,22.525a3,3,0,0,1-2.419-.117L1,19V12H2c1.105,0,3.906.438,5,2h3a4,4,0,0,1,4,4H7"
          fill="none"
          stroke="#162941"
          strokeMiterlimit="10"
          strokeWidth="1.5"
          data-cap="butt"
          strokeLinecap="butt"
          strokeLinejoin="miter"
        ></path>
        <path
          d="M3.825,9.231A9,9,0,0,1,21,13"
          fill="none"
          stroke="#162941"
          strokeMiterlimit="10"
          strokeWidth="1.5"
          data-cap="butt"
          data-color="color-2"
          strokeLinecap="butt"
          strokeLinejoin="miter"
        ></path>
        <line
          x1="15"
          y1="13"
          x2="23"
          y2="13"
          fill="none"
          stroke="#162941"
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="1.5"
          data-color="color-2"
          strokeLinejoin="miter"
        ></line>
        <line
          x1="12"
          y1="1"
          x2="12"
          y2="4"
          fill="none"
          stroke="#162941"
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="1.5"
          data-color="color-2"
          strokeLinejoin="miter"
        ></line>
      </g>
    </svg>
  )
}

export default withIcon(IconSpecialConsiderations)
